import { IPetsState } from './IPetsState';

export const initialPetsState: IPetsState = {
    unlockedPets: [],
    activePet: null,
    petInDailyLogin: false,
};
